import Vue from "vue";
import store from "@/store";

export default {
  logViewItem(item) {
    if (item == null) return;

    let eventData = {
      id: item.ID,
      name: item.descr,
      category: item.catdescr,
      price: item.price,
      affiliation: store.getters.storeName,
    };

    this.logEvent("view_item", eventData);
  },

  logPurchases(feed) {
    if (feed == null) return;

    let items = [];
    if (feed.items) {
      feed.items.forEach(x => {
        let item = {
          id: x.ID,
          name: x.ord_descr,
          quantity: x.qty,
          price: x.price,
        };
        items.push(item);
      });
    }

    let eventData = {
      transaction_id: feed.referenceID,
      affiliation: store.getters.storeName,
      value: feed.total,
      tax: feed.tax,
      items: items,
    };

    this.logEvent("purchase", eventData);
  },

  logSignUp(method) {
    let eventData = { method: method };
    this.logEvent("sign_up", eventData);
  },

  logEvent(eventName, eventData) {
    Vue.$gtag.event(eventName, eventData);

    if (store.getters.storeGTag) {
      eventData.send_to = store.getters.storeGTag;
      Vue.$gtag.event(eventName, eventData);
    }
  },
};
